import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'

import './Column.scss'

const Column = ({ description, className = '', children, t }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' })
    const [hideDetails, setHideDetails] = useState(isMobile)

    useMediaQuery({ query: '(max-width: 991px)' }, void 0, matches => setHideDetails(matches))

    let options = description.featureProducts
    if (hideDetails) {
        options = options.filter(value => value.enabled && (!value.hasOption || value.productOptionValue !== 0))
    }

    const needDetals = isMobile && description.totalOptions !== description.activeOptions

    const toggleDetails = () => setHideDetails(!hideDetails)

    return (
        <div className={`column ${className}`}>
            {children(description, options, isMobile)}
            {needDetals ? (
                <div className="column__details" onClick={toggleDetails}>
                    {hideDetails ? t('_common.more_details') : t('_components._price_table._column.show_less')}
                </div>
            ) : null}
        </div>
    )
}

export default withTranslation('translations')(Column)
